var _process, _process$setMaxListen;
import Events from 'events';
var PromiseStatus = /*#__PURE__*/function (PromiseStatus) {
  PromiseStatus["Pending"] = "pending";
  PromiseStatus["Fulfilled"] = "fulfilled";
  PromiseStatus["Rejected"] = "rejected";
  return PromiseStatus;
}(PromiseStatus || {});
/**
 * promise缓存函数，默认会基于入参作为key进行缓存进行
 * @param fun 返回值为promise的函数
 * @returns 返回值为promise的函数

// 创建promise缓存 
import { promiseCacher } from '@cui/lcp-tools';
import axios from 'axios';

function get(params) {
  return axios.get('http://dev.xuelei.com/static/js/area/new.json')
}
const getData = promiseCacher(get);

// 调用
getData().then(res => {
  console.log('1111', res);
});
getData().then(res => {
  console.log('22222', res);
});
setTimeout(() => {
  getData().then(res => {
    console.log('3333', res);
  });
}, 2000);
 */
// 默认，如果为一个特定事件添加了超过10个监听器，EventEmitter将打印一个警告，此处忽略
(_process = process) === null || _process === void 0 ? void 0 : (_process$setMaxListen = _process.setMaxListeners) === null || _process$setMaxListen === void 0 ? void 0 : _process$setMaxListen.call(_process, 0);
export function promiseCacher(fun) {
  var eventEmitter = new Events.EventEmitter();
  var cache = new Map();
  return function () {
    for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
      arg[_key] = arguments[_key];
    }
    var key = JSON.stringify(arg);
    var result = cache.get(key) || {};
    if (result.state === PromiseStatus.Fulfilled) {
      return Promise.resolve(result.value);
    }
    if (result.state === PromiseStatus.Rejected) {
      return Promise.reject(result.value);
    }
    if (!result.state) {
      result.state = PromiseStatus.Pending;
      cache.set(key, result);
      fun.apply(void 0, arg).then(function (v) {
        result.state = PromiseStatus.Fulfilled;
        result.value = v;
        eventEmitter.emit('resolve' + key, result.value);
      }).catch(function (e) {
        result.state = PromiseStatus.Rejected;
        result.value = e;
        eventEmitter.emit('reject' + key, e);
      }).finally(function () {
        cache.set(key, result);
      });
    }
    return new Promise(function (resolve, reject) {
      eventEmitter.once('resolve' + key, resolve);
      eventEmitter.once('reject' + key, reject);
    });
  };
}